import { Helmet } from 'react-helmet-async';
import React from "react";

const SEO = ({ seoData, initialSeo }) => {
  const seo = initialSeo || seoData || {};

  if (!seo) {
    return null;
  }

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seo?.meta_title || 'Default Title'}</title>
      <meta name="keywords" content={seo?.keywords || ''} />
      <meta name="description" content={seo?.description || ''} />
      <link rel="canonical" href={seo?.canonical_tag || ''} />

      {/* Open Graph Meta Tags */}
      <meta property="og:locale" content={seo?.og_locale || 'en_US'} />
      <meta property="og:type" content={seo?.og_type || 'website'} />
      <meta property="og:title" content={seo?.og_title || 'Default Title'} />
      <meta property="og:description" content={seo?.og_description || 'Default description'} />
      <meta property="og:url" content={seo?.og_url || ''} />
      <meta property="og:site_name" content={seo?.og_site_name || 'Default Site Name'} />
      {seo.og_image_url && <meta property="og:image" content={seo.og_image_url} />}

      {/* Twitter Meta Tags */}
      <meta name="twitter:card" content={seo?.meta_twitter_card || 'summary_large_image'} />
      <meta name="twitter:site" content={seo?.meta_twitter_site || '@default_site'} />
      <meta name="twitter:title" content={seo?.meta_twitter_title || 'Default Title'} />
      <meta name="twitter:description" content={seo?.meta_twitter_description || 'Default description'} />
      {seo.meta_twitter_image && <meta name="twitter:image" content={seo.meta_twitter_image} />}
      {seo.meta_twitter && <meta name="twitter:creator" content={seo.meta_twitter} />}

      {/* Faq Schema */}
      {seo.faq_schema && (
        <script type="application/ld+json">
          {(seo.faq_schema)}
        </script>
      )}
      {seo.article_schema && (
        <script type="application/ld+json">
          {(seo.article_schema)}
        </script>
      )}

      {seo.local_schema && (
        <script type="application/ld+json">
          {(seo.local_schema)}
        </script>
      )}

      {seo.review_schema && (
        <script type="application/ld+json">
          {(seo.review_schema)}
        </script>
      )}
      {seo.organization_schema && (
        <script type="application/ld+json">
          {(seo.organization_schema)}
        </script>
      )}
      {seo.video_schema && (
        <script type="application/ld+json">
          {(seo.video_schema)}
        </script>
      )}

      {seo.product_schema && (
        <script type="application/ld+json">
          {(seo.product_schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;